import type { SxProps, Theme } from '@mui/material';

export const styles = {
    wrapper: {
        display: 'flex',
        justifyContent: 'center',
        py: { xs: 2, md: 4 },
        px: { xs: 1.5, md: 3 },
    } as SxProps<Theme>,
    stack: {
        width: { xs: '100%', md: '70%', lg: '60%' },
        display: 'flex',
        flexDirection: 'column',
    } as SxProps<Theme>,
    sectionTitle: {
        textAlign: 'center',
        my: 3,
        fontSize: 20,
        fontWeight: 400,
        color: 'grey.900',
    } as SxProps<Theme>,
    fields: {
        display: 'flex',
        flexDirection: 'column',
        gap: 2.5,
    } as SxProps<Theme>,
    actions: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: 1,
        mt: 3,
    } as SxProps<Theme>,
    saveBtn: (theme: Theme): SxProps<Theme> => ({
        backgroundColor: theme.palette.blue[700],
        color: theme.palette.white,
        textTransform: 'none',
        '&:hover': { backgroundColor: theme.palette.blue[800] },
    }),
};
